"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var remote_user_1 = __importDefault(require("../constants/actions/remote-user"));

var auth_1 = __importDefault(require("../constants/actions/auth"));

function default_1() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    extra_info: null,
    is_loading_change_nickname: false,
    error_on_change_nickanme: null
  };
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case remote_user_1.default.ON_EXTRA_INFO_UPDATE:
      return Object.assign({}, state, {
        extra_info: action.extra_info
      });

    case remote_user_1.default.CHANGE_NICKNAME_INIT:
      {
        return Object.assign({}, state, {
          is_loading_change_nickname: true,
          error_on_change_nickanme: null
        });
      }

    case remote_user_1.default.CHANGE_NICKNAME_SUCCESS:
      {
        return Object.assign({}, state, {
          is_loading_change_nickname: false
        });
      }

    case remote_user_1.default.CHANGE_NICKNAME_FAILURE:
      {
        return Object.assign({}, state, {
          is_loading_change_nickname: false,
          error_on_change_nickanme: action.error
        });
      }

    case auth_1.default.SIGN_OUT_SUCCESS:
      return Object.assign({}, state, {
        extra_info: null
      });

    default:
      return state;
  }
}

exports.default = default_1;